export default {
    cn:require('./cn'),
    en:require('./en')
}